import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import axios from "axios";
import Swal from 'sweetalert2';
import axiosInstance from '../axiosInstance';

function Cancelbill() {

    const [registrationNo, setRegistrationNo] = useState('');
    const [billdate, setBillDate] = useState('');
    const [result, setResult] = useState([]);
    const [searchText, setSearchText] = useState('');

    function formatDate(dateStr) {
        if (!dateStr) return ''; // Return empty string if dateStr is undefined or empty

        const date = new Date(dateStr); // Convert date string to Date object

        return date.toLocaleDateString('en-GB', {
            day: 'numeric',    // 10
            month: 'numeric',    // Mar
            year: 'numeric'    // 2024
        });
    }

    const handlecancelbill = async (billNo, dealerID) => {
        const result = Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Cancel this Bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Cancel it!',
        });

        if ((await result).isConfirmed) {
            console.log("inrequest: ", billNo, dealerID)
            try {
                const response = await axiosInstance.put(
                    `/cancelbill/${billNo}`,
                    {}, // Empty body
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                );
                console.log(response.data);

                if (response) {
                    const updateResponse = await axiosInstance.put(`/dealer/isactive/${dealerID}`, {});

                    console.log("Dealer updated:", updateResponse.data.message);
                } else {
                    console.warn("Dealer ID not changed to active");
                }
                Swal.fire('Deleted!', 'The bill has been Cancelled.', 'success');
                handleClear();
            } catch (error) {
                console.error('Error fetching data', error);
                Swal.fire('Error', error.response?.data?.error, 'error');
                if (error.response) {
                    // Server responded with a status code outside the 2xx range
                    Swal.fire('Error', error.response.data.error || 'An error occurred.', 'error');
                } else if (error.request) {
                    // Request was made but no response was received
                    Swal.fire('Error', 'No response from server. Please check your connection.', 'error');
                } else {
                    // Other errors
                    Swal.fire('Error', error.message, 'error');
                }
            }

        }
    };

    const handleSearch = async (e) => {
        e.preventDefault();

        if ((!billdate)) {
            Swal.fire('Error!', 'Please Give the value to search for Bill Details', 'error');
            return;
        }

        try {
            const response = await axiosInstance.post('/cancelbill/searchbill', {
                billdate: billdate
            });
            console.log(response.data)
            setResult(response.data);
        } catch (error) {
            console.error('Error fetching data', error);
            Swal.fire('Error', error.response?.data?.error, 'error');
            setResult([]);
        }
    };

    const handleClear = () => {
        setResult([]);
        setRegistrationNo('');
        setBillDate('');
    };

    const filteredData = (Array.isArray(result) ? result : []).filter(item =>
        (String(item.registration_no).toLowerCase().includes(searchText.toLowerCase())) ||
        item.bill_data?.date?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.bill_data?.buyer_name?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.bill_data?.buyer_city?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.bill_data?.bike_model?.toLowerCase().includes(searchText.toLowerCase()) ||
        String(item.bill_data?.amount || '').toLowerCase().includes(searchText.toLowerCase())
    );




    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Registration No</span>,
            selector: row => row.registration_no || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Bill Date</span>,
            selector: row => formatDate(row.bill_data.date),
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Buyer Name</span>,
            selector: row => row.bill_data?.buyer_name || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>City</span>,
            selector: row => row.bill_data?.buyer_city || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Model</span>,
            selector: row => row.bill_data?.bike_model || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Amount</span>,
            selector: row => row.bill_data?.amount || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    <button onClick={() => handlecancelbill(row.bill_data?.id, row.bill_data?.dealer_id)} className="btn btn-danger btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            ),
            width: '250px'
        }
    ];

    return (
        <div className="content-wrapper">
            <div className="content-header bg-light py-3 mb-3 border-bottom">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <h2 className="m-0">Cancel Billing</h2>
                        </div>
                        <div className="col-md-4 text-right">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb bg-transparent p-0 mb-0 justify-content-end">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Cancel Billing</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <form onSubmit={handleSearch} className="mb-4"
                    onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                >
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label htmlFor="billDate" className="font-weight-bold">Select Bill Date</label>
                                        <input
                                            type="date"
                                            id="billDate"
                                            className="form-control"
                                            value={billdate}
                                            onChange={(e) => setBillDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="text-right">
                                        <button type="submit" className="btn btn-primary mr-2">
                                            <i className="fas fa-search mr-1"></i>Search
                                        </button>
                                        <button type="button" className="btn btn-secondary" onClick={handleClear}>
                                            <i className="fas fa-eraser mr-1"></i>Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                {result.length > 0 && (
                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow-sm">
                                <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0"><i className="fas fa-list-alt mr-2"></i>Bill Records</h5>
                                    <div className="input-group" style={{ width: '300px' }}>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><i className="fas fa-search"></i></span>
                                        </div>
                                        <input
                                            type="text"
                                            placeholder="Search..."
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className="card-body">
                                    <DataTable
                                        columns={columns}
                                        data={filteredData}
                                        pagination
                                        paginationPerPage={100}
                                        paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                        highlightOnHover
                                        striped
                                        responsive
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

}

export default Cancelbill